import './IconShape.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var iconShape = _7a468({defaultClassName:'_1jwo1lm0-3-8-0',variantClassNames:{active:{true:'_1jwo1lm1-3-8-0',false:'_1jwo1lm2-3-8-0'}},defaultVariants:{},compoundVariants:[]});